<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between">
              <h6 class="mb-2">Instalaciones</h6>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row p-2">
              <div class="col-12">
                <input v-model="search" type="text" class="form-control" placeholder="Buscar..." />
              </div>
            </div>
            <table class="table align-items-center">
              <thead>
              <th class="text-center">Código</th>
              <th class="text-center">Contrato</th>
              <th class="text-center">Marca</th>
              <th class="text-center">Sitio</th>
              <th class="text-center">Fecha</th>
              <th class="text-center">Estado</th>
            </thead>
              <tbody>
                <Loading v-if="isLoading" />
                <tr v-for="(install, index) in paginatedInstalls" :key="index">
                  <td class="w-20">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <h6 class="mb-0 text-sm"><a :href="'/install/'+install._id">{{ install.Name }}</a></h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm" v-if="install.Campana__c !=null">{{ install.Campana__c.Name }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ install.Marca__c }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ install.Sitio__c }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm" v-if="install.FechaInstalacion__c !=null">{{ getFormattedDate(install.FechaInstalacion__c) }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ install.Estado__c }}</h6>
                        </div>
                      </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-4 p-2">
              <button class="btn btn-dark" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">Anterior</button>
              <button class="btn btn-dark mx-2" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">Siguiente</button>
            </div>
          </div>
          <div v-if="!hasInstalls && !isLoading" class="text-center">
            <img :src="folder" style="max-width: 20%;" />
            <h4>No se encontraron registros</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import Loading from '../../examples/Loading.vue';
import folder from "@/assets/img/folder.png";
import moment from 'moment';
export default {
  name: "tables",
  components: {
    Loading,
  },
  data() {
    return {
      folder,
      installs: [],
      isLoading: false,
      search: "",
      perPage: 10,
      currentPage: 1,
    };
  },
  computed: {
    filteredInstalls() {
      return this.installs.filter((install) => {
        const search = this.search.toLowerCase();

        return (
          (install.Name && install.Name.toLowerCase().includes(search)) ||
          (install.Campana__c && install.Campana__c.Name && install.Campana__c.Name.toLowerCase().includes(search)) ||
          (install.Marca__c && install.Marca__c.toLowerCase().includes(search)) ||
          (install.Sitio__c && install.Sitio__c.toLowerCase().includes(search)) ||
          (install.Estado__c && install.Estado__c.toLowerCase().includes(search))
        );
      });
    },
    paginatedInstalls() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredInstalls.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredInstalls.length / this.perPage);
    },
  },
  methods: {
    async fetchInstalls() {
      this.isLoading = true;
      let id = localStorage.getItem('AccountId');
      fetch(this.$EndPoint + 'instalaciones/get_by_owner/' + id)
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          this.installs = result;
          if (this.installs.length > 0) {
            this.hasInstalls = true;
          } else {
            this.hasInstalls = false;
          }
          this.isLoading = false;
        });
    },
    getFormattedDate(date) {
      return moment(date).format("YYYY-MM-DD")
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  created() {
    if (localStorage.getItem('IsLoggedIn') == 'true') {
      this.fetchInstalls();
    } else {
      this.$router.push('/signin');
    }
  },
};
</script>   